import { render, staticRenderFns } from "./ClientPreferenceDialog.vue?vue&type=template&id=32debf3a&"
import script from "./ClientPreferenceDialog.vue?vue&type=script&lang=js&"
export * from "./ClientPreferenceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports